import { render } from "./UserReviews.vue?vue&type=template&id=c5d46188&scoped=true"
import script from "./UserReviews.vue?vue&type=script&lang=js"
export * from "./UserReviews.vue?vue&type=script&lang=js"

import "./UserReviews.vue?vue&type=style&index=0&id=c5d46188&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d46188"]])

export default __exports__